import { gql } from 'graphql-request';

export const CREATE_POA_DRAFT = gql`
  mutation CreatePoaDraft($inviteId: ID) {
    corePOA {
      createDraft(invitationId: $inviteId)
    }
  }
`;
